<template>
    <div class="form__wrapper">
        <div class="regirect">
            <div class="text">Don't have an account?</div>
            <router-link :to="{ name: 'registration' }">
                Create Account
            </router-link>
        </div>
        <div class="form__content">
            <form action="">
                <div class="title">Sign In</div>
                <InputWrapper>
                    <template #text>
                        email
                    </template>
                    <template #input>
                        <Input v-model:value="v$.auth_data.email.$model" :class="{ 'error': v$.auth_data.email.$invalid && submitted }"></Input>
                    </template>
                </InputWrapper>
                <InputWrapper>
                    <template #text>
                        Password
                    </template>
                    <template #input>
                        <InputPassword v-model:password="v$.auth_data.password.$model" :class="{ 'error': v$.auth_data.password.$invalid && submitted }"></InputPassword>
                    </template>
                </InputWrapper>
                <div style="display: flex; justify-content: space-between; align-items: center;">
                    <RememberMeButton></RememberMeButton>

                    <router-link class="forgot__password" :to="{ name: 'forgot-password' }">
                        Forgot your password?
                    </router-link>
                </div>
                <SubmitButton @click="SubmitAuth">Sign In</SubmitButton>
                <SocialAuth></SocialAuth>
            </form>
        </div>
    </div>
    <StatusRequest ref="toast"></StatusRequest>
</template>

<script>
import InputWrapper from '../InputWrapper.vue';
import Input from '../Input.vue';
import InputPassword from '../InputPassword.vue';
import RememberMeButton from '../RememberMeButton.vue';
import SubmitButton from '../SubmitButton.vue';
import SocialAuth from '../SocialAuth.vue';
import axios from "axios";
import StatusRequest from "@/components/UI/StatusRequest.vue";
import messages from '@/assets/json/messages.json';
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength} from '@vuelidate/validators';
    export default {
        setup: () => ({ v$: useVuelidate() }),
        components: {
            InputWrapper,
            Input,
            RememberMeButton,
            SubmitButton,
            SocialAuth,
            StatusRequest,
            InputPassword
        },
        data() {
            return {
                auth_data: {
                    email: null,
                    password: null,
                    remember_me: false,
                },
                messages: messages,
                request: false,
                submitted: false,
            }
        },
        validations() {
            return {
                auth_data: {
                    email: { required, email },
                    password: { required, minLength: minLength(8) },
                }
            }
        },
        methods: {
            async SubmitAuth(e) {
                this.submitted = true;
                e.preventDefault();
                if(this.request){
                    return false;
                }
                this.request = true;
                this.v$.$touch();
                if (this.v$.auth_data.$invalid) {
                    this.request = false;
                }
                else {
                    let current_arr = JSON.parse(JSON.stringify(this.auth_data));
                    let fData = new FormData();

                    fData.append("login", current_arr.email);
                    fData.append("password", current_arr.password);
                    try {
                        const response = await axios.post("/user/login/account/auth", fData);
                        window.localStorage.setItem("auth_token", response.data.token);
                        setTimeout(() => {
                            this.$router.push({name: "AccountOrders"});
                        }, 500);
                    } catch (error) {
                        if (error.response && error.response.status === 400) {
                        this.showMessage(false, this.getErrorMessage('invalid_credentials'));
                        } else {
                        this.showMessage(false, this.getErrorMessage('unknown_error'));
                        }
                    }
                    finally{
                        this.request = false;
                    }
                    }
                },
                getErrorMessage(key) {
                return this.messages.errors.login[key];
                },
                showMessage(type, title) {
                if(type) type='success';
                else type="error";
                const toast = this.$refs.toast;
                toast.show(type,title,5000);
                }
        },
    }
</script>

<style scoped>
.forgot__password{
    color: rgb(5, 5, 5);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
}
.form__wrapper{
    padding: 24px 0;
    height: 100%;
}
.regirect{
    display: flex;
    justify-content: right;
    gap: 16px;
    align-items: center;
}
.regirect .text{
    color: rgb(5, 5, 5);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    }
.regirect a{
    background: rgb(222, 230, 234);
    border-radius: 32px;
    padding: 10px 24px;

    color: rgb(5, 5, 5);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
}
.form__content{
    height: calc(100% - 14px);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
form{
    width: 322px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.title{
    color: rgb(5, 5, 5);
    font-size: 24px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    padding-bottom: 1px;
}
</style>